import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { Text, TextProps } from 'localmed-core';

import { DisplayErrorState } from './types';
import { coalesceFieldErrors, shouldDisplayErrors } from './utils';

export type Props = TextProps & {
  name: string;
  displayErrorState?: DisplayErrorState;
  children: React.ReactNode;
};

export default class FieldHint extends React.Component<Props> {
  render() {
    const { name, displayErrorState, children, ...props } = this.props;
    return (
      <Field
        name={name}
        subscription={{
          dirty: true,
          touched: true,
          error: true,
          submitError: true,
          dirtySinceLastSubmit: true,
        }}
      >
        {({ meta }: FieldRenderProps) => {
          if (
            shouldDisplayErrors(meta, displayErrorState) &&
            coalesceFieldErrors(meta).length > 0
          ) {
            return null;
          }
          return (
            <Text fontSize="sm" lineHeight="text" color="muted" {...props}>
              {children}
            </Text>
          );
        }}
      </Field>
    );
  }
}
